import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

type CTAT = {
  title: React.ReactNode;
  body: string;
  button: string;
};

const defaultT: CTAT = {
  title: <>Ready to <span className="urgent-cyan">focus together?</span></>,
  body: "Body doubling, live study streams, and a global community — completely free.",
  button: "Join now",
};

export const CTA = ({ t = defaultT }: { t?: CTAT }) => {
  return (
    <section className="py-24 border-t border-border" aria-labelledby="cta-title">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <article className="max-w-3xl mx-auto text-center space-y-8">
          <h2 id="cta-title" className="font-display text-5xl sm:text-6xl leading-[1.05] tracking-tight" style={{ fontWeight: 400 }}>
            {t.title}
          </h2>

          <p className="font-display italic text-xl sm:text-2xl text-muted-foreground leading-relaxed" style={{ fontWeight: 400 }}>
            {t.body}
          </p>

          <div className="flex justify-center pt-2">
            <Button
              size="lg"
              className="group bg-primary hover:bg-primary/90 text-primary-foreground font-sans font-light px-8 py-6 text-lg glow-primary transition-all hover:scale-105"
              asChild
            >
              <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                {t.button}
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </Button>
          </div>
        </article>
      </div>
    </section>
  );
};
